module.exports = __webpack_public_path__ + "img/logout.58d1a7a4.png";